import { render, staticRenderFns } from "./MsgToSuperTalkDetails.vue?vue&type=template&id=13f25680&scoped=true"
import script from "./MsgToSuperTalkDetails.vue?vue&type=script&lang=js"
export * from "./MsgToSuperTalkDetails.vue?vue&type=script&lang=js"
import style0 from "./MsgToSuperTalkDetails.vue?vue&type=style&index=0&id=13f25680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f25680",
  null
  
)

export default component.exports